// extracted by mini-css-extract-plugin
module.exports = {"schoolAdmin":"#00ADE6","schoolAdmin110":"#01a3da","schoolTeacher":"#8C61CB","schoolTeacher110":"#7b40d4","primaryColor":"var(--accent-color)"};